import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"

import { Skeleton } from "@particles/index"

import { Icon } from "@atoms/index"

import { useJobPreviewCard } from "@pages/Jobs/JobList/views/JobTimelineView/JobPreviewCard/JobPreviewCard.context"

import styles from "./JobPreviewLocationDetail.module.scss"
import { JobPreviewLocationDetailProps } from "./JobPreviewLocationDetail.types"

export default function JobPreviewLocationDetail(props: JobPreviewLocationDetailProps) {
    const { location } = props

    const { isLoading } = useJobPreviewCard()

    if (isLoading && !location) {
        return <Skeleton width={16} height={16} />
    }

    return (
        <div className={styles.base}>
            <span className={styles.jobLocationIcon}>
                <Icon icon={icon({ name: "map", style: "light", family: "sharp" })} />
            </span>
            <p className={styles.locationAddress}>{location}</p>
        </div>
    )
}
